export default __webpack_public_path__ + "static/media/img_06.82e03452.webp";